import {faFacebook, faInstagram} from "@fortawesome/free-brands-svg-icons";
import {faPlus, faBars} from "@fortawesome/free-solid-svg-icons";
import DOMPurify from "dompurify";
import React, {useState} from "react";
import {createStaticRanges} from "react-date-range/dist/defaultRanges";
import {addDays, startOfWeek, endOfWeek, startOfDay, endOfDay, startOfMonth, endOfMonth, addMonths} from "date-fns";

const defineds = (week_starts_on) => {
  return {
    startOfWeek: startOfWeek(new Date(), {weekStartsOn: week_starts_on}),
    endOfWeek: endOfWeek(new Date(), {weekStartsOn: week_starts_on}),
    startOfLastWeek: startOfWeek(addDays(new Date(), -7), {weekStartsOn: week_starts_on}),
    endOfLastWeek: endOfWeek(addDays(new Date(), -7), {weekStartsOn: week_starts_on}),
    startOfToday: startOfDay(new Date()),
    endOfToday: endOfDay(new Date()),
    startOfYesterday: startOfDay(addDays(new Date(), -1)),
    endOfYesterday: endOfDay(addDays(new Date(), -1)),
    startOfMonth: startOfMonth(new Date()),
    endOfMonth: endOfMonth(new Date()),
    startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
    endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),
  }
};

export const JSON_HEADERS = {
  'Accept': 'application/json',
  'Content-Type': 'application/json'
};

export const UI_ACTIONS = {
  TOGGLE_SHOW_ADD_NEW_PAGE_MODAL_VISIBILITY: "TOGGLE_SHOW_ADD_NEW_PAGE_MODAL_VISIBILITY",
  TOGGLE_SHOW_FEEDBACK_MODAL_VISIBILITY: "TOGGLE_SHOW_FEEDBACK_MODAL_VISIBILITY",
  SHOW_MODERATION: "SHOW_MODERATION",
  SHOW_PREVIEW_PANEL: "SHOW_PREVIEW_PANEL",
  SHOW_EMOJI_MODAL: "SHOW_EMOJI_MODAL",
  SHOW_SAVED_REPLIES: "SHOW_SAVED_REPLIES",
  REPLY_SENT_ADD: "REPLY_SENT_ADD",
  REPLY_SENT_DELETE: "REPLY_SENT_DELETE",
  SHOW_SEARCH: "SHOW_SEARCH",
  SET_PREVIEW_DATA: "SET_PREVIEW_DATA",
  SHOW_BRANDS_MODAL: "SHOW_BRANDS_MODAL",
  SET_SELECT_TYPE: "SET_SELECT_TYPE",
  SELECTED_COMMENTS_COUNT: "SELECTED_COMMENTS_COUNT"
}

export const PAGES_ACTIONS = {
  LOAD_FACEBOOK_PAGES_STARTED: "LOAD_FACEBOOK_PAGES_STARTED",
  LOAD_FACEBOOK_PAGES_COMPLETED: "LOAD_FACEBOOK_PAGES_COMPLETED",
  LOAD_FACEBOOK_PAGES_FAILED: "LOAD_FACEBOOK_PAGES_FAILED",
  REQUEST_PAGE_DETAILS_SUCCESS: "REQUEST_PAGE_DETAILS_SUCCESS",
  RESET_PAGE_DETAILS: "RESET_PAGE_DETAILS",
  ADD_PAGE_DETAILS: "ADD_PAGE_DETAILS",
  UPDATE_PAGE_DETAILS: "UPDATE_PAGE_DETAILS",
  REMOVE_FACEBOOK_PAGES_FROM_ACTIVE: "REMOVE_FACEBOOK_PAGES_FROM_ACTIVE",
  ADD_COMMENT_WEBHOOK: "ADD_COMMENT_WEBHOOK",
  CHANGE_PAGE: "CHANGE_PAGE",
  DELETE_COMMENT_WEBHOOK: "DELETE_COMMENT_WEBHOOK",
  INC_UNREVIEWED_COMMENTS_COUNTER: "INC_UNREVIEWED_COMMENTS_COUNTER",
  DEC_UNREVIEWED_COMMENTS_COUNTER: "DEC_UNREVIEWED_COMMENTS_COUNTER",
  SET_UNREVIEWED_COMMENTS_COUNTER: "SET_UNREVIEWED_COMMENTS_COUNTER",

  REQUEST_RULES: "REQUEST_RULES",
  ADD_RULES: "ADD_RULES",
  UPDATE_RULES: "UPDATE_RULES",
  REMOVE_RULES: "REMOVE_RULES"
}

export const COMMENTS_ACTIONS = {
  REQUEST_PAGE_COMMENTS_STARTED: "REQUEST_PAGE_COMMENTS_STARTED",
  REQUEST_PAGE_COMMENTS_FAILED: "REQUEST_PAGE_COMMENTS_FAILED",
  REQUEST_PAGE_COMMENTS_SUCCESS: "REQUEST_PAGE_COMMENTS_SUCCESS",
  REQUEST_COMMENTS_COUNTER_STARTED: "REQUEST_COMMENTS_COUNTER_STARTED",
  REQUEST_COMMENTS_COUNTER_FAILED: "REQUEST_COMMENTS_COUNTER_FAILED",
  REQUEST_COMMENTS_COUNTER_SUCCESS: "REQUEST_COMMENTS_COUNTER_SUCCESS",
  ADD_NEW_COMMENT: "ADD_NEW_COMMENT",
  ADD_NEW_TMP_COMMENT: "ADD_NEW_TMP_COMMENT",
  RESET_TMP_COMMENTS: "RESET_TMP_COMMENTS",
  ADD_NEW_COMMENTS: "ADD_NEW_COMMENTS",
  DELETE_COMMENT: "DELETE_COMMENT",
  DELETE_COMMENTS: "DELETE_COMMENTS",
  DELETE_REPLY: "DELETE_REPLY",
  UPDATE_COMMENT: "UPDATE_COMMENT",
  CHANGE_FILTER: "CHANGE_FILTER",
  LOAD_LINKS: "LOAD_LINKS",
  CHANGE_LINKS: "CHANGE_LINKS",
  BAN_USER: "BAN_USER",
  MUTE_USER: "MUTE_USER",
  FLAG_USER: "FLAG_USER",
  HIDE_ALL_REPLY_FORMS: "HIDE_ALL_REPLY_FORMS",
  SHOW_REPLY_FORM: "SHOW_REPLY_FORM",
  REQUEST_USER_NOTIFICATIONS: "REQUEST_USER_NOTIFICATIONS",
  ADD_USER_NOTIFICATIONS: "ADD_USER_NOTIFICATIONS",
  UPDATE_USER_NOTIFICATIONS: "UPDATE_USER_NOTIFICATIONS",
  REMOVE_USER_NOTIFICATIONS: "REMOVE_USER_NOTIFICATIONS"
}

export const USER_ACTIONS = {
  REQUEST_USER_DETAILS_STARTED: "REQUEST_USER_DETAILS_STARTED",
  REQUEST_USER_DETAILS_SUCCESS: "REQUEST_USER_DETAILS_SUCCESS",
  REQUEST_USER_DETAILS_FAILED: "REQUEST_USER_DETAILS_FAILED",
  ADD_FACEBOOK_PAGES_TO_USER: "ADD_FACEBOOK_PAGES_TO_USER",
  REMOVE_FACEBOOK_PAGES_FROM_USER: "REMOVE_FACEBOOK_PAGES_FROM_USER",
  INC_PAGES_COUNT: "INC_PAGES_COUNT",
  DEC_PAGES_COUNT: "DEC_PAGES_COUNT",
  UPDATE_USER_SUB_USERS: "UPDATE_USER_SUB_USERS",
  REQUEST_SAVED_REPLIES: "REQUEST_SAVED_REPLIES",
  ADD_SAVED_REPLIES: "ADD_SAVED_REPLIES",
  UPDATE_SAVED_REPLIES: "UPDATE_SAVED_REPLIES",
  REMOVE_SAVED_REPLIES: "REMOVE_SAVED_REPLIES",
  REQUEST_USER_NOTIFICATIONS: "REQUEST_USER_NOTIFICATIONS",
  ADD_USER_NOTIFICATIONS: "ADD_USER_NOTIFICATIONS",
  UPDATE_USER_NOTIFICATIONS: "UPDATE_USER_NOTIFICATIONS",
  REMOVE_USER_NOTIFICATIONS: "REMOVE_USER_NOTIFICATIONS",
  UPDATE_PROFILE: "UPDATE_PROFILE",
  API_ERROR: "API_ERROR",
  CHANGE_PAGE: "CHANGE_PAGE"
}

export const BRANDS_ACTIONS = {
  REQUEST_BRANDS: "REQUEST_BRANDS",
  ADD_BRANDS: "ADD_BRANDS",
  UPDATE_BRANDS: "UPDATE_BRANDS",
  REMOVE_BRANDS: "REMOVE_BRANDS",
  INIT_PAGES: "INIT_PAGES",
  ADD_PAGES: "ADD_PAGES",
  REMOVE_PAGES: "REMOVE_PAGES",
  INIT_CURRENT_PAGES: "INIT_CURRENT_PAGES",
  ADD_CURRENT_PAGES: "ADD_CURRENT_PAGES",
  REMOVE_CURRENT_PAGES: "REMOVE_CURRENT_PAGES",
  SET_SELECTED_BRAND: "SET_SELECTED_BRAND",
  UPDATE_STATUS: "UPDATE_STATUS",
  ADD_FAQ: "ADD_FAQ",
  UPDATE_FAQ: "UPDATE_FAQ",
  REMOVE_FAQ: "REMOVE_FAQ",
}

export const DIRECT_MESSAGES_ACTIONS = {
  REQUEST_MESSAGES: "REQUEST_MESSAGES",
  REQUEST_MORE_MESSAGES_SUCCESS: "REQUEST_MORE_MESSAGES_SUCCESS",
  REQUEST_CONVOS: "REQUEST_CONVOS",
  REQUEST_MESSAGES_COUNTER_STARTED: "REQUEST_MESSAGES_COUNTER_STARTED",
  REQUEST_MESSAGES_COUNTER_FAILED: "REQUEST_MESSAGES_COUNTER_FAILED",
  REQUEST_MESSAGES_COUNTER_SUCCESS: "REQUEST_MESSAGES_COUNTER_SUCCESS",
  ADD_DIRECT_MESSAGES: "ADD_DIRECT_MESSAGES",
  DELETE_DIRECT_MESSAGE: "DELETE_DIRECT_MESSAGE",
  UPDATE_DIRECT_MESSAGE: "UPDATE_DIRECT_MESSAGE",
  ADD_CONVO: "ADD_CONVO",
  UPDATE_CONVO: "UPDATE_CONVO",
  DELETE_CONVO: "DELETE_CONVO",
  ADD_MESSAGE_WEBHOOK: "ADD_MESSAGE_WEBHOOK",
  DELETE_MESSAGE_WEBHOOK: "DELETE_MESSAGE_WEBHOOK",
  ADD_CONVO_WEBHOOK: "ADD_CONVO_WEBHOOK",
  ADD_LAST_ACTIVE: "ADD_LAST_ACTIVE",
  CHANGE_DM_FILTER: "CHANGE_DM_FILTER",
  SET_UNARCHIVED_CONVOS_COUNT: "SET_UNARCHIVED_CONVOS_COUNT",
  UPDATE_MESSAGE_WEBHOOK: "UPDATE_MESSAGE_WEBHOOK",
  CONVO_TO_TOP: "CONVO_TO_TOP"
}

export const CSRF = document.querySelector("meta[name='csrf-token']").getAttribute("content");

export const webPurifyLangs = { en: 'English', ar: 'Arabic', fr: 'French', de: 'German', hi: 'Hindi', ja: 'Japanese',
  it: 'Italian', pt: 'Portuguese', ru: 'Russian', es: 'Spanish', th: 'Thai', tr: 'Turkish',
  zh: 'Chinese (beta)',
  ko: 'Korean (beta)',
  pa: 'Punjabi (beta)' }

export const getIcon = (type) => {
  switch (type) {
    case "facebook_page":
      return faFacebook
      break;
    case "instagram_page":
      return faInstagram
      break;
    case "dashboard":
      return faBars
      break;
    default:
      return faPlus
  }
}

const defaultOptions = {
  ALLOWED_TAGS: [ 'strong', 'a', 'br' ],
  ALLOWED_ATTR: ['target', 'href', 'class']
};

const sanitize = (dirty, options) => ({
  __html: DOMPurify.sanitize(
      dirty,
      { ...defaultOptions, ...options }
  )
});

export const sanitizeToText = (dirty) =>
    DOMPurify.sanitize(dirty, {
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: []
    });

export const SanitizeHTML = ({ html, options, className}) => (
    <div className={className} dangerouslySetInnerHTML={sanitize(html, options)} />
);


export const rolesInfo = {
  moderator: "<strong>Moderators</strong> have full access to comments, but they do not have access to moderation settings or account wide settings (like adding or removing pages).",
  manager: "<strong>Managers</strong> have full access to comments and moderation settings, but they do not have access to account wide settings (like adding or removing pages).",
  administrator: "<strong>Administrators</strong> have full access to comments, moderation settings and account wide settings (like adding or removing pages)."
}

export const filterList = {
  status: ["Hidden", "Visible"],
  comments_type: ["Ad comments", "Organic comments"],
  label: ["Profanity","Negativity","Custom", "Impersonator", "URL","Email & Phone","Mention", "Hashtag","Image","Emoji","All"],
  replied: ["Yes", "No"],
  intent: ["Needs reply", "Doesn’t need reply"],
  time: ["Last 24 hours","Last 7 days","Last 14 days","Last 30 days"]
}

export const isIE = () => {
  const userAgent = navigator.userAgent;
  return (userAgent.indexOf("MSIE") > -1 || userAgent.indexOf("Trident") > -1);
}

export const numberWithCommas = (x) => {
  return x.toLocaleString();
}

export const defaultSystemInstruction = 'You are a customer support agent that will answer to comments and support questions based on your information about the company, brand, products, services, etc.\n\n' +
    'Always answer from the second-person point of view. You are an employee the company so always say "we" and "our" and never "they" or "their".\n\n' +
    'Don’t give a factual answer about something that is not explicitly listed in the information that is available to you.\n\n' +
    'Just give the answer and not add sentences to describe what you\'re going to do like: "Sure, I can help you with that. Let me search through our files to find the information, just a moment."'


export const defaultNeedsPrompt = 'Does the following comment contain a question that needs a reply?'

export const getFilenameFromContentDisposition = (contentDisposition) => {
  if (!contentDisposition) {
    return null;
  }

  let filename = null;

  // Try to match filename* (RFC 5987)
  // Example: filename*=UTF-8''your-filename.ext
  const filenameStarMatch = contentDisposition.match(/filename\*=\S*?''(.*?)($|;)/i);
  if (filenameStarMatch && filenameStarMatch[1]) {
    try {
      filename = decodeURIComponent(filenameStarMatch[1]);
    } catch (e) {
      // Fallback or error handling if decodeURIComponent fails
      console.warn('Error decoding filename*:', e);
    }
  }

  // If filename* not found or failed, try to match filename= (RFC 2616)
  // Example: filename="your-filename.ext"
  if (!filename) {
    const filenameMatch = contentDisposition.match(/filename="([^"]*)"/i);
    if (filenameMatch && filenameMatch[1]) {
      filename = filenameMatch[1];
    } else {
      // Fallback for filename without quotes (less common but possible)
      const filenameUnquotedMatch = contentDisposition.match(/filename=([^;]*)/i);
      if (filenameUnquotedMatch && filenameUnquotedMatch[1]) {
        filename = filenameUnquotedMatch[1].trim();
      }
    }
  }

  // Browsers sometimes URL-decode the path component of the filename in Content-Disposition
  // e.g. /tmp/file.csv becomes %2Ftmp%2Ffile.csv in the header, which then decodes back.
  // If the filename still contains URL-encoded slashes from a path, extract the base name.
  if (filename && filename.includes('%2F')) {
    try {
      filename = decodeURIComponent(filename);
    } catch (e) {
      // If full decode fails, proceed with what we have
    }
  }

  if (filename && (filename.includes('/') || filename.includes('\\'))) {
    filename = filename.substring(filename.lastIndexOf('/') + 1);
    filename = filename.substring(filename.lastIndexOf('\\') + 1);
  }

  return filename;
}

export const week_days = {sun: "Sunday", mon: "Monday"}

export const defaultStaticRanges = (week_starts_on) => createStaticRanges([
  {
    label: 'Today',
    range: () => ({
      startDate: defineds(week_starts_on).startOfToday,
      endDate: defineds(week_starts_on).endOfToday,
    }),
  },
  {
    label: 'Yesterday',
    range: () => ({
      startDate: defineds(week_starts_on).startOfYesterday,
      endDate: defineds(week_starts_on).endOfYesterday,
    }),
  },

  {
    label: 'This Week',
    range: () => ({
      startDate: defineds(week_starts_on).startOfWeek,
      endDate: defineds(week_starts_on).endOfWeek,
    }),
  },
  {
    label: 'Last Week',
    range: () => ({
      startDate: defineds(week_starts_on).startOfLastWeek,
      endDate: defineds(week_starts_on).endOfLastWeek,
    }),
  },
  {
    label: 'This Month',
    range: () => ({
      startDate: defineds(week_starts_on).startOfMonth,
      endDate: defineds(week_starts_on).endOfMonth,
    }),
  },
  {
    label: 'Last Month',
    range: () => ({
      startDate: defineds(week_starts_on).startOfLastMonth,
      endDate: defineds(week_starts_on).endOfLastMonth,
    }),
  },
]);

let originalTitle = document.title;
let originalFavicon = null;
let notificationFavicon = null;
let notificationCount = 0;
let initialized = false;

function ensureInitialized() {
  if (initialized) return;

  const faviconElement = document.getElementById('favicon');
  if (!faviconElement) return;

  originalFavicon = faviconElement.href;

  const img = document.createElement('img');
  img.src = originalFavicon;

  img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;

    const ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0, img.width, img.height);
    ctx.beginPath();
    ctx.arc(
        img.width - img.width / 5,
        img.height / 5,
        img.width / 5,
        0,
        2 * Math.PI
    );
    ctx.fillStyle = '#f00000';
    ctx.fill();

    notificationFavicon = canvas.toDataURL('image/png');
  };

  initialized = true;
}

function updateFavicon(href) {
  const faviconElement = document.getElementById('favicon');
  if (!faviconElement) return;

  // Safari workaround: force refresh by removing, re-adding, and using a dummy href first
  const clone = faviconElement.cloneNode();
  clone.href = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgUyHbBAAAAAASUVORK5CYII=';

  faviconElement.parentNode.replaceChild(clone, faviconElement);

  setTimeout(() => {
    clone.href = href;
  }, 50);
}

export function addNotification(count = null) {
  ensureInitialized();

  if (typeof count === 'number') {
    notificationCount = count;
  } else {
    notificationCount++;
  }

  document.title = `(${notificationCount}) ${originalTitle}`;

  if (notificationFavicon) {
    updateFavicon(notificationFavicon);
  }
}

export function clearNotifications() {
  ensureInitialized();
  notificationCount = 0;
  document.title = originalTitle;

  if (originalFavicon) {
    updateFavicon(originalFavicon);
  }
}
